import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import classNames from 'classnames';
import { AuroraButton, ADGMModal } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

function RemoveContactModal(props) {
  const { modalConfig, handleModalClose, handleRemovePrimaryContact, buttonText, classes } = props;

  const onModalClose = () => {
    handleModalClose();
  };

  const removePrimaryContact = () => {
    handleRemovePrimaryContact(modalConfig?.data);
  };

  return (
    <ADGMModal
      open={modalConfig.open}
      toggleModal={onModalClose}
      onClose={onModalClose}
      disablePortal
      className={classes.removeModal}
    >
      <Box display='flex' justifyContent='flex-end'>
        <IconButton aria-label='close' className={classes.crossIconBtn} onClick={onModalClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box className={classes.removeContainer}>
        <Box className={classes.removeContent}>
          <Typography variant='h5'> {keyEmptyCheck('Remove primary contact?')}</Typography>
          <Typography>
            {keyEmptyCheck('are_you_sure_you_want_to_remove_primary_contact', {
              s: <b>{modalConfig?.data?.nameEn}</b>,
            })}
          </Typography>
        </Box>
        <Box className={classes.removeActions} mt={5}>
          <Box display='flex' justifyContent='space-between' className={classes.subPanel}>
            <AuroraButton type='button' onClick={onModalClose}>
              {keyEmptyCheck('discard')}
            </AuroraButton>
            <Button className={classNames(classes.mediumButton, classes.addBuyerButton)} onClick={removePrimaryContact}>
              {buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </ADGMModal>
  );
}

RemoveContactModal.propTypes = {
  classes: PropTypes.object.isRequired,
  modalConfig: PropTypes.object.isRequired,
  buttonText: PropTypes.node.isRequired,
  handleRemovePrimaryContact: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired,
};

RemoveContactModal.defaultProps = {};

export default RemoveContactModal;
